export const storekeeperForm = [
  {
    type: "text",
    label: "Storekeeper Name",
    name: "name",
    required: true,
    placeholder: "Enter storekeeper name",
  },
  {
    type: "text",
    label: "Role",
    name: "role",
    required: true,
    placeholder: "Enter storekeeper role",
  },
  {
    type: "email",
    label: "Email",
    name: "email",
    required: true,
    placeholder: "Enter email address",
    userField: true,
  },
  {
    type: "password",
    label: "Password",
    name: "password",
    placeholder: "Enter password",
    userField: true,
  },
];
